import { createIcon } from '@chakra-ui/react';

export const HeartIcon = createIcon({
  displayName: 'HeartIcon',
  viewBox: '0 0 32 32',
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none">
      <path
        d="M15.9993 2.66602C14.2484 2.66602 12.5146 3.01089 10.8969 3.68096C9.27923 4.35102 7.80937 5.33314 6.57126 6.57126C4.07077 9.07174 2.66602 12.4631 2.66602 15.9993C2.66602 19.5356 4.07077 22.927 6.57126 25.4274C7.80937 26.6656 9.27923 27.6477 10.8969 28.3177C12.5146 28.9878 14.2484 29.3327 15.9993 29.3327C19.5356 29.3327 22.927 27.9279 25.4274 25.4274C27.9279 22.927 29.3327 19.5356 29.3327 15.9993C29.3327 14.2484 28.9878 12.5146 28.3177 10.8969C27.6477 9.27923 26.6656 7.80937 25.4274 6.57126C24.1893 5.33314 22.7195 4.35102 21.1018 3.68096C19.4841 3.01089 17.7503 2.66602 15.9993 2.66602ZM15.9993 5.33268C18.8283 5.33268 21.5414 6.45649 23.5418 8.45688C25.5422 10.4573 26.666 13.1704 26.666 15.9993C26.666 18.8283 25.5422 21.5414 23.5418 23.5418C21.5414 25.5422 18.8283 26.666 15.9993 26.666C13.1704 26.666 10.4573 25.5422 8.45688 23.5418C6.45649 21.5414 5.33268 18.8283 5.33268 15.9993C5.33268 13.1704 6.45649 10.4573 8.45688 8.45688C10.4573 6.45649 13.1704 5.33268 15.9993 5.33268ZM12.9993 10.426C10.946 10.426 9.33268 12.0393 9.33268 14.0927C9.33268 16.6127 11.5993 18.666 15.0393 21.786L15.9993 22.666L16.9593 21.786C20.3993 18.666 22.666 16.6127 22.666 14.0927C22.666 12.0393 21.0527 10.426 18.9993 10.426C17.8393 10.426 16.7327 10.9727 15.9993 11.826C15.266 10.9727 14.1593 10.426 12.9993 10.426Z"
        fill="#27273A"
      />
    </svg>
  ),
});
